import React, { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import RegisterDetailsForm from './forms/register-details.form';
import './auth.scss';
import AppIcons from '../../assets/images/icons';

const RegisterDetailsPage = () => {
    const isLogin = useRef(null);

    useEffect(() => {
        const isLoginPage = isLogin.current;
        if (isLoginPage && isLoginPage.classList.contains('login-class-adder')) {
            document.body.classList.add('login-page');
        } else {
            document.body.classList.remove('login-page');
        }
        return () => {
            document.body.classList.remove('login-page');
        };
    }, []);

    return (
        <>
            <div ref={isLogin} className={`login-class-adder login-wrpx register-wrp register-detail-wrp main-content-wrapper auth-layout`}>
                <div className='auth-page-layout f-wrp'>
                    <div className={`flex-box`}>
                        <div className='form-sec-wrp' style={{ position: 'relative' }}>
                            <div className='auth-form'>
                                <Link to={'/'} className='auth-logo'>
                                    <img src={AppIcons.logo} alt='Pnp ai Logo' />
                                </Link>
                                <br /> <br />
                                <RegisterDetailsForm />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='form-img-wrp'>
                    <span>
                        <img src={AppIcons.loginBG1} alt='PnP login' />
                    </span>
                </div>
            </div>
        </>
    );
};

export default RegisterDetailsPage;
